export default __webpack_public_path__ + "d609bd2eb8882e396304fc15bf1134d3.png";